import "./Card.scss";

import React from "react";

interface CardProps {
  type: "primary" | "secondary";
  children: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ type, children }) => {
  return <div className={`card ${type}`}>{children}</div>;
};

export default Card;
